import { map, Observable, of } from 'rxjs';

import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, forwardRef, Injector, Input, NgModule, OnChanges, ViewEncapsulation } from '@angular/core';
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { Entity, StatusFilterValue, SystemWorkOrderStatus, WorkOrderStatusUtility } from '@jms/model';
import { PickerItemModule, PickerItemStyle } from '@jms/ui/ui.picker.item';
import { PickerBaseComponent, PickerFetch } from '@jms/ui/ui.pickers.base';
import { NgSelectModule } from '@ng-select/ng-select';


@Component({
    selector: 'job-status-tree-picker',
    templateUrl: './job.status.tree.picker.component.html',
    styleUrls: ['./job.status.tree.picker.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => JobStatusTreePickerComponent),
            multi: true
        }
    ],
    standalone: false
})
export class JobStatusTreePickerComponent extends PickerBaseComponent implements OnChanges {

    @Input() public data: StatusFilterValue[];
    @Input() public placeholder = '<Status>';
    @Input() public allowClear = false;
    @Input() public appendTo;
    @Input() public selectableGroup = false;

    public data$: Observable<StatusFilterValue[]>;

    public readonly PickerItemStyle = PickerItemStyle;

    constructor(
        injector: Injector,
        private http: HttpClient
    ) {
        super(injector);
    }

    public ngOnChanges() {

        const data$ = this.fetch === PickerFetch.Automatic
            ? this.getLabels()
            : of(this.data);

        this.data$ = data$//.pipe(map(x => this.updateOrder(x)));

    }

    private getLabels(): Observable<StatusFilterValue[]> {
        return this.http.get<StatusFilterValue[]>(`/api/picker/job/statuses/tree`)
            .pipe(
                map(data => data.filter(x => !x.isSystemStatus))
            )
    }


    public compareFn(data1: Entity, data2: Entity): Boolean {
        // data will included category & subcategory
        if (!data1?._id || !data2?._id) {
            return false;
        }

        const same = data1?._id === data2?._id;
        return same;
    }


    public getGroup(groupKey: string, children: any[]) {

        const group: StatusFilterValue = {
            _id: groupKey,
            name: `${groupKey}: All`,
            systemStatus: groupKey as SystemWorkOrderStatus,
            isSystemStatus: true,
            sortOrder: 0,
            systemName: groupKey
        }

        return group;
    }

    public getColor(systemStatus: string): string {
        return WorkOrderStatusUtility.getSystemColor(systemStatus as SystemWorkOrderStatus);
    }

}

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        NgSelectModule,
        PickerItemModule,
    ],
    declarations: [
        JobStatusTreePickerComponent
    ],
    providers: [],
    exports: [
        JobStatusTreePickerComponent
    ],
})
export class JobStatusTreePickerModule { }
